import { render, staticRenderFns } from "./InterpreterInfoSection.vue?vue&type=template&id=908628a0&scoped=true&"
import script from "./InterpreterInfoSection.vue?vue&type=script&lang=js&"
export * from "./InterpreterInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterInfoSection.vue?vue&type=style&index=0&id=908628a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908628a0",
  null
  
)

export default component.exports